import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import './assets/css/reset.css';
import './assets/font/iconfont.css';
import 'element-ui/lib/theme-chalk/index.css';

import local from './utils/local';
// Vue.prototype.$local=local;

import './utils/formatTime';
Vue.prototype.bus = new Vue()
Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
